module.exports = __webpack_public_path__ + "img/py.661ee4e1.svg";